/**
 * 스피너 (Promise)
 *
 * 사용법 ex)
 *
 * // 기본
 * spinner.show().then(resolve,reject).then(function(){ spinner.hide(); });
 *
 * // 프리셋 사용
 * spinner.show("gray").then(...)
 *
 * // 커스텀 스타일: 프리셋 참조
 * var style = spinner.presets.gray
 * var style.size = 50;
 * spinner.show(style).then(...)
 *
 * // 커스텀 스타일
 * spinner.show({
 *     img : "//ws.cconma.com/assets/images/loader.gif",
 *     size: 80,
 *     bg : "rgba(255, 255, 255, 0.9)"
 * }).then(...)
 */

(function (root, factory) {
    // AMD(require.js) ready?
    if (typeof define === 'function' && define.amd) {
        // window에 jquery가 있으면 no-dependency
        if (root.$ || root.jQuery) {
            define([], factory);
        }
        // window에 jquery가 없음.
        else {
            define(["jquery"], factory);
        }
    } else {
        root.spinner = factory();
    }
})(this, function (optionalJquery) {

    var $; // local jQuery

    // inject 안되었나(고전 방식)?
    if (typeof optionalJquery === "undefined") {
        $ = window.$ || window.jQuery;
    } else {
        $ = optionalJquery;
    }

    /**
     * 스피너의 최상위 컨테이너 셀렉터 준비
     * @param {string} container_selector
     * @return {*|string}
     */
    function prepareContainerSelector(container_selector) {
        container_selector = container_selector ? container_selector : 'body';
        if (!counter.hasOwnProperty(container_selector)) {
            counter[container_selector] = 0;
        }
        return container_selector;
    }

    /**
     *
     * @param {object} style
     * @param {string} message
     * @param {string} container_selector
     * @returns {jQuery}
     */
    function prepareSpinner(style, message, container_selector) {
        // noinspection JSJQueryEfficiency
        $spinner = $(container_selector).find('.cconma-spinner');
        if ($spinner.length === 0) {
            $(container_selector).append("" +
                "<style type=\"text/css\" class='cconma-spinner-style-injected'>" +
                (container_selector !== 'body' ? container_selector + "{" +
                    "       position: relative;" +
                    "   }" : "") +
                container_selector + " .cconma-spinner {" +
                "       display: none;" +
                (container_selector !== 'body' ? "position: absolute;" : "position: fixed;") +
                "       width: 100%;" +
                "       height: 100%;" +
                "       top: 0;" +
                "       left: 0;" +
                "       z-index: 2000;" +
                "       backface-visibility: hidden;" +
                "       background-color: " + style.bg + ";" +
                "   }" +
                container_selector + " .cconma-spinner-box {" +
                "       position: absolute;" +
                "       text-align: center;" +
                "       top: 50%;" +
                "       left: 50%;" +
                "       transform: translate(-50%, -50%);" +
                "       width: 200px;" +
                "       height: 150px;" +
                "       border-radius: 5px;" +
                "       background-color: " + style.box_bg + ";" +
                "       background-position: center;" +
                "       display: flex;" +
                "       justify-content: center;" +
                "       align-items: center;" +
                "   }" +
                container_selector + " .cconma-spinner-box .cconma-spinner-img {" +
                "       width: " + style.size + "px;" +
                "       height: " + style.size + "px;" +
                "       background-position: center;" +
                "   }" +
                container_selector + " .cconma-spinner-box .cconma-spinner-message {" +
                "       position: relative;" +
                "       width: 300px;" +
                "       margin-left: -150px;" +
                "       margin-top: 20px;" +
                "       padding-left: 100%;" +
                "       text-align: center;" +
                "       font-size: " + style.font_size + "px;" +
                "       color: " + style.color +
                "   }" +
                "</style>" +
                "<div class=\"cconma-spinner\">" +
                "   <div class='cconma-spinner-box'>" +
                "       <div class=\"cconma-spinner-img\">" +
                "           <img src=\"" + style.img + "\" alt=\"loading...\" height=\"" + style.size + "\" width=\"" + style.size + "\" >" +
                "           <div class='cconma-spinner-message'></div>" +
                "       </div>" +
                "   </div>" +
                "</div>"
            )
            ;
            $spinner = $(container_selector).find('.cconma-spinner');
        }

        if (message) {
            $spinner.find(".cconma-spinner-message").html(message);
        }

        return $spinner;
    }

    var counter = [];
    var $spinner;

    return {
        presets: {
            default     : { // 파란색
                img: "//ws.cconma.com/Images/Mobile/Ccapp/Icon/loading_gray.gif",
                // img : "//ws.cconma.com/assets/images/loader.gif",
                size     : 46,
                bg       : "rgba(255, 255, 255, 0)",
                box_bg   : "transparent",
                font_size: 15,
                color    : "#000000"
            },
            gray_dim    : { // 회색 (66x66)
                img      : "//ws.cconma.com/Images/Mobile/Ccapp/Icon/loading_gray.gif",
                size     : 46,
                bg       : "rgba(255, 255, 255, 0.7)",
                box_bg   : "transparent",
                font_size: 15,
                color    : "#000000"
            },
            gray        : { // 회색 (66x66)
                img      : "//ws.cconma.com/Images/Mobile/Ccapp/Icon/loading_gray.gif",
                size     : 46,
                bg       : "rgba(255, 255, 255, 0)",
                box_bg   : "transparent",
                font_size: 15,
                color    : "#000000"
            },
            gray_small  : { // 회색 (24x24)
                img      : "//ws.cconma.com/Images/pmv/order/ajax-loader.gif",
                size     : 24,
                bg       : "rgba(255, 255, 255, 0)",
                box_bg   : "transparent",
                font_size: 15,
                color    : "#000000"
            },
            gray_smaller: { // 회색 (66x66)
                img      : "//ws.cconma.com/Images/Mobile/Ccapp/Icon/loading_gray.gif",
                size     : 24,
                bg       : "rgba(255, 255, 255, 0)",
                box_bg   : "transparent",
                font_size: 15,
                color    : "#000000"
            }
        },
        /**
         * 스타일 노멀라이즈
         * @param {string|object} [style_param] default="default"
         * @returns {Object}
         */
        normalizeStyle: function (style_param) {
            /**
             * @type {Object}
             */
            var style = undefined;
            if (typeof style_param === "object") {
                style = style_param;
            } else {
                style_param = style_param || "default";
                style       = this.presets[style_param];
            }
            return style;
        },

        /**
         * 스피너 표시(Promise)
         * @param {string|object} [style_param] default="default"
         * @param {string} [message]
         * @param {string} [container_selector] 컨테이너 네임
         * @param {*} [debug_msg]
         * @returns {Promise}
         */
        show: function (style_param, message, container_selector, debug_msg) {
            container_selector = prepareContainerSelector(container_selector);
            /**
             * @type {Object}
             */
            var style          = this.normalizeStyle(style_param);

            return new Promise(function (resolve, reject) {
                whenDomReady(function () {
                    $spinner = prepareSpinner(style, message, container_selector);
                    counter[container_selector]++;
                    if (debug_msg) {
                        // console.log(counter + ' show ' + debug_msg);
                    }
                    $spinner.show();
                    resolve();
                });
            });
        },

        /**
         * 스피너 표시(즉각)
         * @param {string|object} [style_param] default="default"
         * @param {string} [message]
         * @param {string} [container_selector] 컨테이너 네임
         */
        showImmediate: function (style_param, message, container_selector) {
            container_selector = prepareContainerSelector(container_selector);

            /**
             * @type {Object}
             */
            var style = this.normalizeStyle(style_param);

            whenDomReady(function () {
                $spinner = prepareSpinner(style, message, container_selector);
                counter[container_selector]++;
                $spinner.show();
            });
        },

        /**
         * 스피너 감춤(Promise)
         * @param {string} [container_selector]
         * @param {*} [debug_msg]
         * @returns {Promise}
         */
        hide: function (container_selector, debug_msg) {
            if(container_selector)
            {
                $spinner = $(container_selector).find('.cconma-spinner');
            }
            container_selector = prepareContainerSelector(container_selector);
            return new Promise(function (resolve, reject) {
                counter[container_selector]--;
                if (debug_msg) {
                    // console.log(counter + ' hide ' + debug_msg);
                }
                if (counter[container_selector] < 0) {
                    return reject("spinner hide underflow");
                }

                // 스피너가 여러번 호출된 상태?
                if (counter[container_selector] > 0) {
                    return resolve();
                }

                // 마지막 스피너 닫기
                $spinner.fadeOut(0, function () {
                    $(container_selector).find(".cconma-spinner-style-injected").remove();
                    $(container_selector).find(".cconma-spinner").remove();
                    return resolve();
                });
            });
        },

        /**
         * 스피너 감춤(즉각)
         * @param {string} [container_selector]
         * @returns {string} 스피너 감춤 실패 메시지
         */
        hideImmediate: function (container_selector) {
            container_selector = prepareContainerSelector(container_selector);

            counter[container_selector]--;
            if (counter[container_selector] < 0) {
                return "spinner hide underflow";
            }

            // 스피너가 여러번 호출된 상태?
            if (counter[container_selector] > 0) {
                return "more spinner layers";
            }

            // 마지막 스피너 닫기
            $spinner.fadeOut(0, function () {
                $(container_selector).find(".cconma-spinner-style-injected").remove();
                $(container_selector).find(".cconma-spinner").remove();
            });
            return "";
        }
    }
});